
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parlor/[id]",
      function () {
        return require("private-next-pages/parlor/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parlor/[id]"])
      });
    }
  